import React from 'react';

const CTAsection = () => {
    return (
        <div className="w-50 mx-auto text-center my-5">
            <div className="card mb-5 bg-primary">
                <div className="card-body p-5">
                    <h2 className="h2 fw-bold mb-4 text-dark">Can't find what you're looking for?</h2>
                    <button className="btn btn-dark">Contact PCSS Catalogue Team</button>
                </div>
            </div>
        </div>
    );
};

export default CTAsection;
